import { useState } from 'react';
import { Input, FormErrorMessage, Box } from '@chakra-ui/react';

const PANInput = ({ name, value = '', onChange, isEditMode }) => {
  const [inputValue, setInputValue] = useState(value);
  const [isValid, setIsValid] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [touched, setTocuched] = useState(false);


  const handleInputChange = (event) => {
    const newValue = event.target.value.toUpperCase(); // Convert input to uppercase
    setInputValue(newValue);

    // PAN validation regex
    const regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
    const isValidPAN = regex.test(newValue);
    setIsValid(isValidPAN);

    if(isValidPAN){
      setTocuched(false);
    }

    onChange({ target: { name: event.target.name, value: newValue } });
  };

  const handleInputBlur = () => {
    setIsHovered(false);
    if (!isValid) {
      setIsValid(false);
    }
    if(!inputValue){
      setTocuched(false);
      setIsValid(true);
    }
  };

  const handleInputFocus = () => {
    setIsHovered(true);
    setTocuched(true);
  };

  return (
    <>
      <Input
        name={name}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        onFocus={handleInputFocus}
        isInvalid={!isValid && !isHovered}
        disabled={isEditMode}
      />
      {!isValid && touched && !isHovered &&  (
        <Box color={'red'}>
          Please enter a valid Pan No.
        </Box>
      )} 
    </>
  );
};

export default PANInput;
